module.exports = __webpack_public_path__ + "media/bandicam 2021-06-23 10-10-04-856.825aa9b3.mp4";